<template>
    <div class="feature-icon-base no-badge" style="transform: scale(0.7);">
        <div class="icon" :class="color">
            <div class="circle">
                <div v-if="icon == ''" class="custom-icon">
                    <slot></slot>
                </div>
                <a-icon class="fa" v-else :type="icon"></a-icon>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        color: String,
        icon: { type: String, default: '' }
    }
}
</script>

<style>
.feature-icon-base.show-badge .circle .fa {
  margin-top: 8px !important;
}
.feature-icon-base {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  position: relative;
  display: inline-block;
}
.feature-icon-base .icon {
  position: relative;
  margin: 0 20px;
  width: 56px;
  height: 87px;
  border-radius: 10px;
  display: inline-block;
  top: 0;
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.feature-icon-base .icon.yellow {
  background: -webkit-gradient(linear, left top, right bottom, from(#ffeb3b), to(#fbc02d));
  background: -o-linear-gradient(top left, #ffeb3b 0%, #fbc02d 100%);
  background: linear-gradient(to bottom right, #ffeb3b 0%, #fbc02d 100%);
  color: #ffb300;
}
.feature-icon-base .icon.orange {
  background: -webkit-gradient(linear, left top, right bottom, from(#ffc107), to(#f57c00));
  background: -o-linear-gradient(top left, #ffc107 0%, #f57c00 100%);
  background: linear-gradient(to bottom right, #ffc107 0%, #f57c00 100%);
  color: #f68401;
}
.feature-icon-base .icon.pink {
  background: -webkit-gradient(linear, left top, right bottom, from(#f48fb1), to(#d81b60));
  background: -o-linear-gradient(top left, #f48fb1 0%, #d81b60 100%);
  background: linear-gradient(to bottom right, #f48fb1 0%, #d81b60 100%);
  color: #dc306f;
}
.feature-icon-base .icon.red {
  background: -webkit-gradient(linear, left top, right bottom, from(#f4511e), to(#b71c1c));
  background: -o-linear-gradient(top left, #f4511e 0%, #b71c1c 100%);
  background: linear-gradient(to bottom right, #f4511e 0%, #b71c1c 100%);
  color: #c62828;
}
.feature-icon-base .icon.purple {
  background: -webkit-gradient(linear, left top, right bottom, from(#ab47bc), to(#4527a0));
  background: -o-linear-gradient(top left, #ab47bc 0%, #4527a0 100%);
  background: linear-gradient(to bottom right, #ab47bc 0%, #4527a0 100%);
  color: #7127a8;
}
.feature-icon-base .icon.teal {
  background: -webkit-gradient(linear, left top, right bottom, from(#4db6ac), to(#00796b));
  background: -o-linear-gradient(top left, #4db6ac 0%, #00796b 100%);
  background: linear-gradient(to bottom right, #4db6ac 0%, #00796b 100%);
  color: #34a297;
}
.feature-icon-base .icon.blue {
  background: -webkit-gradient(linear, left top, right bottom, from(#4fc3f7), to(#2196f3));
  background: -o-linear-gradient(top left, #4fc3f7 0%, #2196f3 100%);
  background: linear-gradient(to bottom right, #4fc3f7 0%, #2196f3 100%);
  color: #259af3;
}
.feature-icon-base .icon.blue-dark {
  background: -webkit-gradient(linear, left top, right bottom, from(#1976d2), to(#283593));
  background: -o-linear-gradient(top left, #1976d2 0%, #283593 100%);
  background: linear-gradient(to bottom right, #1976d2 0%, #283593 100%);
  color: #1c68c5;
}
.feature-icon-base .icon.green {
  background: -webkit-gradient(linear, left top, right bottom, from(#cddc39), to(#8bc34a));
  background: -o-linear-gradient(top left, #cddc39 0%, #8bc34a 100%);
  background: linear-gradient(to bottom right, #cddc39 0%, #8bc34a 100%);
  color: #7cb342;
}
.feature-icon-base .icon.green-dark {
  background: -webkit-gradient(linear, left top, right bottom, from(#4caf50), to(#1b5e20));
  background: -o-linear-gradient(top left, #4caf50 0%, #1b5e20 100%);
  background: linear-gradient(to bottom right, #4caf50 0%, #1b5e20 100%);
  color: #00944a;
}
.feature-icon-base .icon.silver,
.feature-icon-base .icon.white,
.feature-icon-base .icon {
  background: -webkit-gradient(linear, left top, right bottom, from(#e0e0e0), to(#bdbdbd));
  background: -o-linear-gradient(top left, #e0e0e0 0%, #bdbdbd 100%);
  background: linear-gradient(to bottom right, #e0e0e0 0%, #bdbdbd 100%);
  color: #9e9e9e;
}
.feature-icon-base .icon.gold {
  background: -webkit-gradient(linear, left top, right bottom, from(#e6ce6a), to(#b7892b));
  background: -o-linear-gradient(top left, #e6ce6a 0%, #b7892b 100%);
  background: linear-gradient(to bottom right, #e6ce6a 0%, #b7892b 100%);
  color: #b7892b;
}
.feature-icon-base .icon::before {
  -webkit-transform: rotate(60deg);
          transform: rotate(60deg);
}
.feature-icon-base .icon::after {
  -webkit-transform: rotate(-60deg);
          transform: rotate(-60deg);
}
.feature-icon-base .icon::before,
.feature-icon-base .icon::after {
  position: absolute;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  background: inherit;
  content: '';
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.feature-icon-base .icon .circle {
  width: 53px;
  height: 53px;
  position: absolute;
  background: #fff;
  z-index: 10;
  border-radius: 50%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
}
.feature-icon-base .icon .circle .fa {
  font-size: 26px;
  margin-top: 14px;
}
.feature-icon-base .icon .circle .custom-icon {
  font-size: 20px;
  margin-top: 12px;
}
.feature-icon-base .icon .badge-label {
  text-align: center;
  position: absolute;
  border-radius: 3px;
  padding: 3px 5px 2px 5px;
  width: 90px;
  z-index: 11;
  color: #fff;
  bottom: 10px;
  left: 50%;
  margin-left: -45px;
  font-size: 12px;
  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.27);
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.27);
  text-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  background: -webkit-gradient(linear, left top, right bottom, from(#555), to(#333));
  background: -o-linear-gradient(top left, #555 0%, #333 100%);
  background: linear-gradient(to bottom right, #555 0%, #333 100%);
  cursor: default;
}
</style>